export const styles = ({
  buttonClass: {
    minWidth: '50%',
  },
});
